<script>
import { authComputed } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";

/**
 * up sell Component
 */
export default {
  page: {
    title: "Intent",
  },
  data() {
    return {
      intentObj: {
        intentId: "",
        intent_name: "",
        video_file_duration: "0",
        slot_cmd: "",
        utterances: [],
        text_reply: "",
        audio_file: "",
        video_file: "",
        is_common: true,
        video_file_status: "0",
        audio_file_status: "0",
      },
      image: "",
      submitted: false,
      isBtnLoading: false,
      isSaveAndAddNew: false,
      createError: false,
      errorMessage: "",
      fileUploadLoading: false,
    };
  },

  computed: {
    ...authComputed,
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "saveAndAddNew", "cancelSubmit"],
  mounted() {
    this.setValue();
  },
  methods: {
    setValue() {
      if (this.currentProps.isEdit) {
        this.intentObj.intentId = this.currentProps.updateValue.intentId;
        this.intentObj.intent_name = this.currentProps.updateValue.intent_name;
        this.intentObj.video_file_duration =
          this.currentProps.updateValue.video_file_duration;
        this.intentObj.slot_cmd = this.currentProps.updateValue.slot_cmd;
        this.currentProps.updateValue.utterances.map((item) => {
          this.intentObj.utterances.push({ value: item });
        });
        this.intentObj.text_reply = this.currentProps.updateValue.text_reply;
        this.intentObj.audio_file = this.currentProps.updateValue.audio_file;
        this.intentObj.video_file = this.currentProps.updateValue.video_file;
        this.intentObj.audio_file_status =
          this.currentProps.updateValue.audio_file_status;
        this.intentObj.video_file_status =
          this.currentProps.updateValue.video_file_status;
      }
    },

    addUtterances() {
      this.intentObj.utterances.push({ value: "" });
    },

    removeUtterances(index) {
      this.intentObj.utterances.splice(index, 1);
    },

    async handleSubmit() {
      let utterances = [];
      this.intentObj.utterances.map((item) => {
        utterances.push(item.value);
      });

      this.submitted = true;
      this.isBtnLoading = true;

      let data = {};
      if (this.currentProps.isEditable) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.isBtnLoading = false;
          return;
        } else {
          data = {
            intent_name: this.intentObj.intent_name,
            utterances: utterances,
            text_reply: this.intentObj.text_reply,
            audio_file: this.intentObj.audio_file,
            video_file: this.intentObj.video_file,
            video_file_status: this.intentObj.video_file_status,
            audio_file_status: this.intentObj.audio_file_status,
            video_file_duration: this.intentObj.video_file_duration,
            slot_cmd: this.intentObj.slot_cmd,
            is_common: true,
          };
          if (!this.currentProps.isEdit) {
            await UserService.addIntent(data)
              .then(async (response) => {
                data.intentId = response.intentId;

                if (this.isSaveAndAddNew) {
                  this.$emit("saveAndAddNew", data);
                } else {
                  this.$emit("submitted", data);
                }
                this.isBtnLoading = false;
                this.submitted = false;
              })
              .catch((error) => {
                this.isBtnLoading = false;
                this.createError = true;
                errorHandler(error);
                Middleware.notification("Something went wrong !!", "danger");

                if (typeof error.response.data.non_field_errors == "object") {
                  this.errorMessage = error.response.data.non_field_errors;
                } else {
                  this.errorMessage = error.response.data;
                }
              });
          } else {
            data.intentId = this.intentObj.intentId;
            UserService.updateIntent(data)
              .then((response) => {
                this.$emit(
                  "submitted",
                  data,
                  this.currentProps.isEdit,
                  this.currentProps.isEditable
                );
                this.isBtnLoading = false;
                this.submitted = false;
                Middleware.notification("Successfully updated !!", "success");
              })
              .catch((error) => {
                this.isBtnLoading = false;
                this.createError = true;
                errorHandler(error);

                if (typeof error.response.data.non_field_errors == "object") {
                  this.errorMessage = error.response.data.non_field_errors;
                } else {
                  this.errorMessage = error.response.data;
                }
              });
          }
        }
      } else {
        let tempObj = {};
        tempObj[this.intentObj.intent_name] = {
          name: this.intentObj.intent_name,
          audio_file: this.intentObj.audio_file,
          video_file: this.intentObj.video_file,
          text_reply: this.intentObj.text_reply,
          video_file_status: this.intentObj.video_file_status,
          audio_file_status: this.intentObj.audio_file_status,
          video_file_duration: this.intentObj.video_file_duration,
          slot_cmd: this.intentObj.slot_cmd,
          is_common: true,
        };

        data = { ...data, ...tempObj };
        data = { ...data, hotel_id: this.currentProps.hotelId };

        data.intentId = this.intentObj.intentId;
        UserService.addUpdateVideoChatHotelIntent(data)
          .then((response) => {
            this.$emit(
              "submitted",
              this.intentObj,
              this.currentProps.isEdit,
              this.currentProps.isEditable
            );
            this.isBtnLoading = false;
            this.submitted = false;
            Middleware.notification("Successfully updated !!", "success");
          })
          .catch((error) => {
            this.isBtnLoading = false;
            this.createError = true;
            errorHandler(error);

            if (typeof error.response.data.non_field_errors == "object") {
              this.errorMessage = error.response.data.non_field_errors;
            } else {
              this.errorMessage = error.response.data;
            }
          });
      }
    },

    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.handleSubmit();
    },

    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },

    async uploadFile(event, type) {
      let fileObject = event.target.files[0];
      let fileName = "";

      if (type == "audio_file") {
        this.intentObj.audio_file = this.currentProps.hotelId
          ? this.currentProps.hotelId + "" + this.randomString(5) + ".mp3"
          : "" + "" + this.randomString(5) + ".mp3";
        fileName = { file_name: this.intentObj.audio_file };
        this.intentObj.audio_file_status = "1";
      } else {
        this.intentObj.video_file = this.currentProps.hotelId
          ? this.currentProps.hotelId + "" + this.randomString(5) + ".mp4"
          : "" + "" + this.randomString(5) + ".mp4";
        fileName = { file_name: this.intentObj.video_file };
        console.log(fileName, "fileName");
        this.intentObj.video_file_status = "1";
      }
      this.fileUploadLoading = true;
      await UserService.mediaFileUrlGenerate(fileName)
        .then((response) => {
          let fileUrl = response.url;
          UserService.mediaFileUpload(fileUrl, fileObject).then((res) => {
            this.fileUploadLoading = false;
            this.submitted = false;
            Middleware.notification(
              "Successfully upload media file !!",
              "success"
            );
          });
        })
        .catch((error) => {
          this.fileUploadLoading = false;
          this.createError = true;
          errorHandler(error);
          Middleware.notification("Something went wrong !!", "success");
          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },

    randomString(length) {
      var result = "";
      var characters = "abcdefghijklmnopqrstuvwxyz";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
  },
  validations: {
    intentObj: {
      intent_name: {
        required,
      },
      video_file_duration: {
        required,
      },
      slot_cmd: {
        required,
      },
      //   fail_reply: {
      //     required,
      //   },
      text_reply: {
        required,
      },
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-12">
      <h4>{{ currentProps.isEdit ? "Edit" : "Add New" }} Intent</h4>
      <hr />
    </div>

    <div class="col-md-6">
      <div class="mb-3">
        <b-form-group class="mb-3" label-for="intent-input">
          <span slot="label"
            >Intent Name <span class="text-danger">*</span></span
          >
          <b-form-input
            :disabled="!currentProps.isEditable"
            id="intent-input"
            type="text"
            placeholder="Intent Name"
            v-model="intentObj.intent_name"
            autocomplete="off"
            :class="{
              'is-invalid': submitted && $v.intentObj.intent_name.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && $v.intentObj.intent_name.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.intentObj.intent_name.required"
              >Intent name is required.</span
            >
          </div>
        </b-form-group>
      </div>
    </div>

    <div class="col-md-6">
      <div class="mb-3">
        <b-form-group class="mb-3" label-for="intent-input">
          <span slot="label"
            >Video File Duration <span class="text-danger">*</span></span
          >
          <b-form-input
            id="intent-input"
            type="text"
            placeholder="Video File Duration"
            v-model="intentObj.video_file_duration"
            autocomplete="off"
            :class="{
              'is-invalid':
                submitted && $v.intentObj.video_file_duration.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && $v.intentObj.video_file_duration.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.intentObj.video_file_duration.required"
              >Video File Duration is required.</span
            >
          </div>
        </b-form-group>
      </div>
    </div>

    <div class="col-md-6">
      <div class="mb-3">
        <b-form-group class="mb-3" label-for="slot-cmd-input">
          <span slot="label">Slot CMD <span class="text-danger">*</span></span>
          <b-form-input
            id="slot-cmd-input"
            type="text"
            placeholder="Slot Cmd"
            v-model="intentObj.slot_cmd"
            autocomplete="off"
            :class="{
              'is-invalid': submitted && $v.intentObj.slot_cmd.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && $v.intentObj.slot_cmd.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.intentObj.slot_cmd.required"
              >Slot CMD is required.</span
            >
          </div>
        </b-form-group>
      </div>
    </div>

    <div class="col-md-6">
      <div class="mb-3" v-if="currentProps.isEditable">
        <div
          class="form-check form-switch form-switch-md d-flex align-items-center mt-4"
        >
          <input
            :disabled="!currentProps.isEditable"
            class="form-check-input"
            type="checkbox"
            v-model="intentObj.is_common"
            id="audio-prompt"
          />
          <label for="audio-prompt" class="form-check-label"
            >is common intent?
          </label>
        </div>
      </div>
    </div>

    <div class="col-md-12 mb-3">
      <h5>
        Manage Utterances
        <span
          class="float-end d-flex align-items-center"
          v-if="currentProps.isEditable"
        >
          Add Utterances
          <i
            class="fas fa-plus-circle text-success ms-2 fs-3 mt-1"
            @click="addUtterances"
          ></i>
        </span>
      </h5>

      <div
        class="mb-3 mt-3"
        v-for="(utterances, index) in intentObj.utterances"
        :key="index"
      >
        <div class="d-flex align-items-center">
          <b-form-input
            :disabled="!currentProps.isEditable"
            :id="index"
            type="text"
            class="w-100 me-3"
            autocomplete="off"
            placeholder="Utterances..."
            v-model="utterances.value"
          ></b-form-input>
          <div v-if="currentProps.isEditable">
            <i
              class="fas fa-minus-circle text-danger fs-3 float-end"
              @click="removeUtterances(index)"
              v-show="index || (!index && intentObj.utterances.length > 1)"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="mb-3">
        <label class="mb-1 mt-3 fw-medium"
          >Success Reply <span class="text-danger">*</span></label
        >
        <textarea
          class="form-control"
          :maxlength="225"
          rows="3"
          placeholder="Success reply..."
          v-model="intentObj.text_reply"
        ></textarea>
      </div>
    </div>
    <!-- <div class="col-md-12">
          <div class="mb-3">
            <b-form-group class="mb-3" label-for="fail-reply-input">
              <span slot="label"
                >Fail Reply <span class="text-danger">*</span></span
              >
              <b-form-input
                id="fail-reply-input"
                type="text"
                placeholder="fail-reply"
                v-model="intentObj.fail_reply"
                autocomplete="off"
                :class="{
                  'is-invalid': submitted && $v.intentObj.fail_reply.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.intentObj.fail_reply.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.intentObj.fail_reply.required"
                  >Fail Reply is required.</span
                >
              </div>
            </b-form-group>
          </div>
        </div> -->
    <!-- <hr /> -->
    <h5 class="mt-4">
      Media

      <div
        class="spinner-border spinner-border-sm"
        role="status"
        v-show="fileUploadLoading"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </h5>

    <div class="col-md-6 mt-2">
      <label for="audio_file">Audio File</label>
      <input
        type="file"
        class="form-control"
        placeholder="Audio file"
        name="audio_file"
        @change="uploadFile($event, 'audio_file')"
        accept="audio/*"
        :src="intentObj.audio_file"
        :disabled="fileUploadLoading"
      />

      <audio controls class="mt-3 w-100" v-if="currentProps.isEdit">
        <source
          :src="
            'https://vod-lex-files.s3.amazonaws.com/' + intentObj.audio_file
          "
          type="audio/mp3"
        />
      </audio>
    </div>
    <div class="col-md-6 mt-2">
      <label for="video_file">Video File</label>
      <input
        type="file"
        class="form-control"
        placeholder="Video File"
        name="video_file"
        @change="uploadFile($event, 'video_file')"
        accept="video/*"
        :src="intentObj.video_file"
        :disabled="fileUploadLoading"
      />
      <video
        width="320"
        height="240"
        controls
        autoplay
        class="mt-3 w-100"
        v-if="currentProps.isEdit"
      >
        <source
          :src="
            'https://vod-lex-files.s3.amazonaws.com/' + intentObj.video_file
          "
        />
      </video>
    </div>
    <div class="col-md-12 mt-4">
      <b-button
        class="float-end ms-2"
        variant="outline-primary"
        type="reset"
        @click="cancelSubmit"
        :disabled="fileUploadLoading"
        >Cancel</b-button
      >
      <b-button
        v-if="this.currentProps.isEdit === false"
        class="float-end ms-2"
        variant="outline-primary"
        type="button"
        :class="{ disabled: isSaveAndAddNew === true && isBtnLoading }"
        @click="saveAndAddNew"
        :disabled="fileUploadLoading"
      >
        <i
          v-if="isSaveAndAddNew === true && isBtnLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
        ></i>
        Save & Add</b-button
      >
      <b-button
        class="float-end"
        :disabled="fileUploadLoading"
        variant="outline-primary"
        @click="handleSubmit"
        :class="{ disabled: isSaveAndAddNew !== true && isBtnLoading }"
      >
        <i
          v-if="isSaveAndAddNew !== true && isBtnLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
        ></i>
        {{ currentProps.isEdit ? "Update" : "Save" }}
      </b-button>
    </div>
  </div>
</template>
